<template>
  <v-dialog fullscreen persistent :value="showDialog" transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>New Schengen Trip</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="$emit('closeSchengenRequest')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container class="text-xs-center">
        <v-layout row wrap>
          <v-flex xs12 class="mb-3">
            <div class="datepicker-trigger">
                <div class="text-xs-left">
                  <div class="mt-3 text-xs-left">
                    <h3><strong>Schengen Trip Dates: </strong></h3>
                  </div>
                  <div id="datepicker-trigger" class="text-xs-left">{{dateOne ? formatDates(dateOne, dateTwo) : 'Please select dates for the new Schengen trip'}}</div>
                  
                    <!-- Schengen Country selection dropbox -->
                    <v-layout class="mt-3" row wrap>
                    <v-flex xs12 sm6>
                      <v-select v-model="selected_country" :items="schengenCountries" label="Select A Country">
                        <template slot="selection" slot-scope="data">
                          <span v-if="data.item.code" :class="'flag flag-' + data.item.code" style="margin-right: 10px;"></span>
                          {{ data.item.text }}
                        </template>
                        <template slot="item" slot-scope="data">
                          <span v-if="data.item.code" :class="'flag flag-' + data.item.code" style="margin-right: 10px;"></span>
                          {{ data.item.text }}
                        </template>
                      </v-select>
                    </v-flex>
                    </v-layout>

                </div>
                <AirbnbStyleDatepicker :trigger-element-id="'datepicker-trigger'" :mode="'range'" :date-one="dateOne"
                :date-two="dateTwo" @date-one-selected="val => { dateOne = val }" @date-two-selected="val => { dateTwo = val }"
                inline :showActionButtons="false" :showShortcutsMenuTrigger="false" />
            </div>
          </v-flex>
          <v-layout v-if="!selected_country" row>
              <v-flex  style="margin: 0px 0px 15px 0px;">
                <h4>Please select a country</h4>
              </v-flex>
          </v-layout>
          <v-layout v-if="dateOne == '' || dateTwo == ''" row>
              <v-flex  style="margin: 0px 0px 15px 0px;">
                <h4>Please select dates for the new Schengen trip</h4>
              </v-flex>
          </v-layout>
          <v-btn color="primary" block class="mb-4" @click="addTrip" :disabled="dateOne == '' || dateTwo == '' || !selected_country || addingTrip">Add Trip</v-btn>
        </v-layout>
      </v-container>
      
    </v-card>
  </v-dialog>
</template>

<script>
  import format from 'date-fns/format'
  import axios from 'axios'
  export default {
    props: ['showDialog'],
    data () {
      return {
        url: this.$store.getters.url,
        dateFormat: 'Do MMMM',
        dateOne: '',
        dateTwo: '',
        addingTrip: false,
        user: this.$store.getters.user,
        company: this.$store.getters.company,
        detailsConfirmed: false,
        loading: false,
        schengenCountries: [],
        selected_country: null
      }
    },
    computed: {
    },
    mounted () {
      this.getSchengenCountries()
    },
    methods: {
      formatDates (dateOne, dateTwo) {
        let formattedDates = ''
        if (dateOne) {
          formattedDates = format(dateOne, this.dateFormat)
        }
        if (dateTwo && dateTwo !== dateOne) {
          formattedDates += ' - ' + format(dateTwo, this.dateFormat)
        }
        return formattedDates
      },
      getSchengenCountries () {
        axios.post(this.url + `/tanda-service/getSchengenCountries.ajax.php`, {
          company: this.company
        })
          .then(response => {
            this.schengenCountries = response.data.map(item => ({
              value: item.country_id,
              text: item.country_name,
              code: item.country_code
            }))
          })
          .catch(e => {
            console.log(e)
          })
      },
      addTrip () {
        this.addingTrip = true
        axios.post(this.url + `/tanda-service/addSchengenTrip.ajax.php`, {
          company: this.company,
          user: this.user,
          startDate: this.dateOne,
          endDate: this.dateTwo,
          emp: this.user.empID,
          country: this.selected_country
        })
          .then(response => {
            if (response.data.success) {
              this.$emit('closeSchengenRequest')
              this.$emit('addedSchengen')
            }
            this.addingTrip = false
          })
          .catch(e => {
            console.log(e)
            this.addingTrip = false
          })
      }
    },
    watch: {
    },
    filters: {
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/SchengenRequest.vue